module.exports = __webpack_public_path__ + "img/69.8db53070.png";